export default {
	affichersuite: 'Afficher la suite',
	affichermoins: 'Afficher moins',
	liensutiles: 'Liens utiles',
	mois1: {
		title: 'A faire avant la fin de ses 1 mois'
	},
	mois2: {
		title: 'A faire avant la fin de ses 2 mois'
	},
	mois3: {
		title: 'A faire avant la fin de ses 3 mois'
	},
	mois4: {
		title: 'A faire avant la fin de ses 4 mois'
	},
	mois6: {
		title: 'A faire avant la fin de ses 6 mois'
	},
	mois8: {
		title: 'A faire avant la fin de ses 8 mois'
	},
	mois11: {
		title: 'A faire avant la fin de ses 11 mois'
	},
	mois12: {
		title: 'A faire avant la fin de ses 12 mois'
	},
	mois15: {
		title: 'A faire avant la fin de ses 15 mois'
	},
	mois18: {
		title: 'A faire avant la fin de ses 18 mois'
	},
	mois23: {
		title: 'A faire avant la fin de ses 24 mois'
	},
	mois24: {
		title: 'A faire avant la fin de ses 2 ans'
	},
	mois36: {
		title: 'A faire avant la fin de ses 3 ans'
	},
	mois48: {
		title: 'A faire avant la fin de ses 4 ans'
	},
	mois60: {
		title: 'A faire avant la fin de ses 5 ans'
	},
	mois84: {
		title: 'A faire avant la fin de ses 7 ans'
	},
	mois108: {
		title: 'A faire avant la fin de ses 9 ans'
	},
	mois156: {
		title: 'A faire avant la fin de ses 13 ans'
	}
};
